/* istanbul ignore file */

const baseStyle = {
  opacity: 1,
};

const divider = {
  baseStyle,
};

export default divider;
